import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SimpleNavbar } from '../../components/layout/SimpleNavbar';
import paymentService from '../../services/paymentService';

export const WaitingVerificationPage = () => {
  const navigate = useNavigate();
  const apiCalled = useRef(false);
  const [apiStatus, setApiStatus] = useState('success'); // default to success since API is now called on PlansSelectionPage

  // NOTE: API call moved to PlansSelectionPage - register-with-payment is now called before Outseta redirect
  // useEffect(() => {
  //   // Prevent double call in strict mode
  //   if (apiCalled.current) return;
  //   apiCalled.current = true;
  //
  //   const callRegisterWithPayment = async () => {
  //     try {
  //       // Get saved registration data from localStorage
  //       const savedRegistrationData = localStorage.getItem('pendingRegistrationData');
  //       const savedSelectedPlan = localStorage.getItem('pendingSelectedPlan');
  //       const savedUserRole = localStorage.getItem('pendingUserRole');
  //
  //       console.log('Pending registration data:', savedRegistrationData);
  //       console.log('Pending selected plan:', savedSelectedPlan);
  //       console.log('Pending user role:', savedUserRole);
  //
  //       if (!savedRegistrationData || !savedSelectedPlan) {
  //         console.log('No pending registration data found, skipping API call');
  //         setApiStatus('no-data');
  //         return;
  //       }
  //
  //       const registrationData = JSON.parse(savedRegistrationData);
  //       const selectedPlan = JSON.parse(savedSelectedPlan);
  //       const userRole = savedUserRole || 'coach';
  //
  //       // Create FormData for multipart/form-data
  //       const formData = new FormData();
  //
  //       // Add registration data
  //       formData.append('firstName', registrationData.firstName);
  //       formData.append('lastName', registrationData.lastName);
  //       formData.append('email', registrationData.email);
  //       formData.append('password', registrationData.password);
  //       formData.append('role', userRole);
  //       formData.append('state', registrationData.state);
  //
  //       // Role-specific fields
  //       if (userRole === 'coach') {
  //         if (registrationData.school) formData.append('school', registrationData.school);
  //         if (registrationData.division) formData.append('division', registrationData.division);
  //         if (registrationData.conference) formData.append('conference', registrationData.conference);
  //         if (registrationData.position) formData.append('position', registrationData.position);
  //       } else if (userRole === 'scout') {
  //         if (registrationData.teamId) formData.append('teamId', registrationData.teamId);
  //         if (registrationData.jobTitle) formData.append('jobTitle', registrationData.jobTitle);
  //       }
  //
  //       // Add payment data
  //       formData.append('paymentProvider', 'outseta');
  //       formData.append('plan', selectedPlan.planId);
  //
  //       // Try to get Outseta access token from URL hash (non-blocking)
  //       const hash = window.location.hash;
  //       if (hash) {
  //         const params = new URLSearchParams(hash.replace('#', ''));
  //         const accessToken = params.get('access_token');
  //         if (accessToken) {
  //           formData.append('outsetaAccessToken', accessToken);
  //           console.log('Outseta access token found:', accessToken);
  //         }
  //       }
  //
  //       console.log('Hitting register-with-payment API...');
  //
  //       // Hit the register-with-payment API
  //       const response = await paymentService.registerWithPayment(formData);
  //       console.log('Register with payment API success:', response);
  //
  //       setApiStatus('success');
  //
  //       // Clean up localStorage after successful API call
  //       localStorage.removeItem('pendingRegistrationData');
  //       localStorage.removeItem('pendingSelectedPlan');
  //       localStorage.removeItem('pendingUserRole');
  //     } catch (error) {
  //       console.error('Register with payment API failed:', error);
  //       setApiStatus('failed');
  //     }
  //   };
  //
  //   callRegisterWithPayment();
  // }, []);

  return (
    <div className="min-h-screen bg-common-gradient">
      <SimpleNavbar />

      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="max-w-3xl w-full text-center">

          {apiStatus === 'loading' && (
            <>
              <h1 className="text-5xl font-anton text-white mb-8">
                COMPLETING REGISTRATION
              </h1>
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-4 border-cyan-400 mb-4"></div>
              <p className="text-cyan-400 font-roboto text-sm">Processing your registration...</p>
            </>
          )}

          {(apiStatus === 'success' || apiStatus === 'no-data') && (
            <>
              <div className="mb-8">
                <svg className="w-20 h-20 text-green-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h1 className="text-5xl font-anton text-white mb-6">
                REGISTRATION SUCCESSFUL!
              </h1>
              <p className="text-base text-gray-300 font-roboto leading-relaxed max-w-2xl mx-auto mb-8">
                Your account has been created successfully. Please log in with your email and password to get started.
              </p>
              <button
                onClick={() => navigate('/auth/login')}
                className="px-10 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-anton text-lg rounded-xl transition-colors"
              >
                GO TO LOGIN
              </button>
            </>
          )}

          {apiStatus === 'failed' && (
            <>
              <div className="mb-8">
                <svg className="w-20 h-20 text-red-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h1 className="text-5xl font-anton text-white mb-6">
                REGISTRATION FAILED
              </h1>
              <p className="text-base text-gray-300 font-roboto leading-relaxed max-w-2xl mx-auto mb-8">
                Something went wrong while processing your registration. Please contact support or try again.
              </p>
              <button
                onClick={() => navigate('/auth/login')}
                className="px-10 py-4 bg-cyan-500 hover:bg-cyan-600 text-white font-anton text-lg rounded-xl transition-colors"
              >
                GO TO LOGIN
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default WaitingVerificationPage;
